<template>
 <v-dialog title="비밀번호 인증확인" v-model="passCheckDialog" persistent max-width="400px">
    <v-row no-gutters align="center" justify="center">
      <v-card id="popStyle02">
        <v-card-text>
          <v-text-field class="inputH48_01" v-model="passWord"
            type="password"
            label="계약열람 비밀번호"
            placeholder="계약열람 비밀번호를 입력해주세요."
            outlined
            rows="2"
            no-resize
            ></v-text-field>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text class="" v-on:click="passCheck">확인</v-btn>
          <v-btn text v-on:click="passCheckDialog = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-row>
    <s-loading ref="loading"></s-loading>
  </v-dialog>
</template>
<script>

import { passCheckReq } from '@/api/contractLock'

export default {
  name: 'passCheck',
  components: {
  },
  filters: {
  },
  props:{
    ctrNumber: String
  },
  data () {
    return {
      passCheckDialog : false,
      passWord : '',
      result : ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open () {
      this.passCheckDialog = true
    },
    passCheck () {
      this.$refs.loading.start('블록체인 비밀번호를 확인중입니다.')
      passCheckReq(JSON.stringify({ ctrNumber: this.ctrNumber, passWord: this.passWord })).then(response => {
        this.$refs.loading.end()
        this.result = response.rdata.result
        this.passCheckDialog = false
        this.$emit('pass-event', this.result)
      })
    }
  }
}
</script>
<style scoped>
</style>
